import { render, staticRenderFns } from "./addCommandCenter.vue?vue&type=template&id=c24dee1e&scoped=true"
import script from "./addCommandCenter.vue?vue&type=script&lang=js"
export * from "./addCommandCenter.vue?vue&type=script&lang=js"
import style0 from "./addCommandCenter.vue?vue&type=style&index=0&id=c24dee1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24dee1e",
  null
  
)

export default component.exports